import VueApollo from 'vue-apollo'
import AWSAppSyncClient from 'aws-appsync'
import AppSyncConfig from '../AppSync.js'
import LoginService from './LoginService.js'

if (LoginService.cognitoUser) {
  LoginService.cognitoUser.getSession(
    function (err, session) {
      if (err) {
        console.log(err)
        console.log(session)
      }
    }
  )
}

const config = {
  url: AppSyncConfig.graphqlEndpoint,
  region: AppSyncConfig.region,
  auth: {
    type: 'AMAZON_COGNITO_USER_POOLS',
    jwtToken: async () => (await LoginService.cognitoUser.getSession(
      function (err, session) {
        if (err) {
          console.log(err)
        }
        return session.getAccessToken().getJwtToken()
      }
    ))
  },
  disableOffline: true
}
const options = {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only'
    },
    query: {
      fetchPolicy: 'network-only'
    },
    mutate: {
      fetchPolicy: 'no-cache'
    }
  }
}

const client = new AWSAppSyncClient(config, options)

const appsyncProvider = new VueApollo({
  defaultClient: client
})

export default {
  appsyncProvider: appsyncProvider
}



// WEBPACK FOOTER //
// ./src/components/AppSyncVT.js